import { createStyles, makeStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  progressButtonWrapper: {
    position: 'relative',
  },
  progress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
  },
  progressContainer: {
    marginTop: -24,
    marginLeft: -24,
  },
  alertContainer: {
    marginBottom: 12,
  },
  alertText: {
    fontSize: 18,
  },
  progressButton: {
    marginTop: -12,
    marginLeft: -12,
  },
  container: {
    height: '100vh',
  },
  form: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
});

const useStyles = makeStyles(styles);

export default useStyles;
